import { Input, Modal, Table } from "antd";
import React, { useState } from "react";
import { svg } from "../../../../../Assets/svg";
import {
  CapitalizeFirstWord,
  momentFullTime,
} from "../../../../../helpers/utils";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { BtnLoader } from "../../../../../Components/Components";
import { decryptByText } from "../../../../../helpers/bycrypt";
import CommonDeleteModal from "../../../../Components/Modals/CommonDeleteModal";
import {
  RootState,
  useAppDispatch,
  useAppSelector,
} from "../../../../../store";
import { getConsoleFunction } from "three";
import { RemovePritedLabelHistory } from "../../../../Redux/orders";

const ViewPrintHistoryDetailsModal: React.FC<{
  visible: boolean;
  setIsModalVisible: any;
  printHistoryData: any;
  setPrintHistoryData: any;
  setPreviewImage: any;
}> = ({
  visible,
  setIsModalVisible,
  printHistoryData,
  setPrintHistoryData,
  setPreviewImage,
}) => {
  const dispatch = useAppDispatch();
  const { removePrintedDataHistoryLoading } = useAppSelector(
    (state: RootState) => state?.loading,
  );
  const [isResetHistoryModal, sertIsResetHistoryModal] = useState(false);

  const onClose = () => {
    sertIsResetHistoryModal(false);
    setIsModalVisible(false);
    setPrintHistoryData(null);
  };
  const columns = [
    {
      title: "Printed By",
      dataIndex: "user_id",
      key: "user_id",
      render: (user_id: any, data: any) => {
        const full_name = `${CapitalizeFirstWord(
          decryptByText(user_id?.first_name),
        )} ${CapitalizeFirstWord(decryptByText(user_id?.last_name))}`;
        return full_name ? `${full_name}` : "-";
      },
    },
    {
      title: "Copies",
      dataIndex: "qty",
      key: "qty",
      render: (qty: any) => (qty ? `${qty}` : "-"),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date: any) => (date ? momentFullTime(date) : "-"),
    },
  ];

  console.log(
    printHistoryData,
    "printHistoryDataprintHistoryDataprintHistoryDataprintHistoryData",
  );
  const handleResetHistory = () => {
    const payload = {
      printed_label_id: printHistoryData?.label_data?.printed_data?._id,
    };
    const handleSuccessPrintReset = () => {
      setPreviewImage((prev: any) =>
        prev?.map((elem: any) => {
          if (elem?.label_data?._id == printHistoryData?.label_data?._id) {
            return {
              ...elem,
              label_data: {
                ...elem?.label_data,
                printed_data: {
                  ...elem?.label_data?.printed_data,
                  print_by: [],
                },
              },
            };
          }
          return elem;
        }),
      );
      sertIsResetHistoryModal(false);
      setIsModalVisible(false);
      setPrintHistoryData(null);
    };
    dispatch(RemovePritedLabelHistory(payload, handleSuccessPrintReset));
  };
  return (
    <Modal
      title={null}
      visible={visible}
      onCancel={onClose}
      width={"40rem"}
      closeIcon={svg.closeIcon}
      centered
      footer={
        <div className="d-flex justify-content-center gap-4 mt-4">
          <button
            type="button"
            className="btn btn-lg btn-outline-secondary"
            onClick={onClose}
          >
            CLOSE
          </button>
          <button
            type="button"
            className="btn btn-lg btn-primary"
            onClick={() => {
              sertIsResetHistoryModal(true);
            }}
          >
            RESET
          </button>
        </div>
      }
      className="commonModalClass"
    >
      <Table
        dataSource={printHistoryData?.label_data?.printed_data?.print_by || []}
        scroll={{ x: "max-content" }}
        pagination={false}
        columns={columns}
        className="custom-table"
        bordered
      />
      {isResetHistoryModal && (
        <CommonDeleteModal
          visible={isResetHistoryModal}
          setIsModalVisible={sertIsResetHistoryModal}
          handleDelete={handleResetHistory}
          title={"Clear Print History, Are You Sure?"}
          description={
            "This action will permanently delete all print history records. This cannot be undone. Please confirm if you want to continue."
          }
          isLoading={removePrintedDataHistoryLoading}
          buttonName="YES, CLEAR"
        />
      )}
    </Modal>
  );
};

export default ViewPrintHistoryDetailsModal;
